/** @jsxImportSource @emotion/react */
import React from "react";
import {css} from "@emotion/react";
import Drawer from "js/common/views/drawer";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";
import * as Styles from "js/common/views/filter-drawer/filters-drawer.styles";
import {TextButton} from "js/common/views/inputs/buttons";
import KpiDrawerMetricTabs from "js/admin/kpis/edit-kpis/common/kpi-drawer-metric-tabs";
import {LoadingBalls} from "js/dashboards/utils";

const KpiDrawerFallback = ({
  open,
  onClose,
  onSave,
  onDiscardChanges,
  changedMetricsCount,
  unOpenedChangedMetricsCount,
  entityTypeToLabel,
  openedKpiIds,
  idToWrappedKpi,
  idToTemplate,
  focusedTabKpiId,
  onLoadUnsavedChangesClick,
  onChangeMetricTab,
  onCloseMetricTab,
  onOpenMetricTab,
  onAddMetricClick
}) => {
  const {theme} = React.useContext(CustomThemeContext);

  return (
      <Drawer
          open={open}
          onRequestClose={onClose}
          showCloseButton={true}
          title="No Metric Selected"
          openRight={true}
          width={"80%"}
      >
        {!idToWrappedKpi ? <LoadingBalls /> :
            <>
              <KpiDrawerMetricTabs
                  entityTypeToLabel={entityTypeToLabel}
                  openedKpiIds={openedKpiIds}
                  focusedKpiTabId={focusedTabKpiId}
                  idToTemplate={idToTemplate}
                  idToWrappedKpi={idToWrappedKpi}
                  onChangeMetricTab={onChangeMetricTab}
                  onCloseMetricTab={onCloseMetricTab}
                  onOpenMetricTab={onOpenMetricTab}
                  onAddMetricClick={onAddMetricClick} />
              <div css={drawerContentStyle(theme)}>
                <div css={emptyStateStyle(theme)}>
                  No Metric Selected - Select a Metric from the Metrics list or by searching in the tab.
                </div>
              </div>
              <div css={drawerControlsStyle(theme, "80%")}>
                <TextButton
                    testId="open-unsaved-metrics-button"
                    disabled={unOpenedChangedMetricsCount < 1}
                    label={`Open Unsaved Metrics (${unOpenedChangedMetricsCount})`}
                    onClick={() => onLoadUnsavedChangesClick()} />
                <div style={{display: "flex", flexGrow: 1}} />
                <TextButton
                    testId="discard-all-changes-button"
                    disabled={changedMetricsCount < 1}
                    label="Discard Changes"
                    onClick={() => onDiscardChanges()}
                    css={discardButtonStyle(theme)} />
                <TextButton
                    testId="save-all-metrics-button"
                    disabled={changedMetricsCount < 1}
                    type="primary"
                    label={`Save All Metrics (${changedMetricsCount})`}
                    onClick={() => onSave()}
                    css={Styles.applyButtonStyle} />
              </div>
            </>
        }
      </Drawer>
  );
};

const drawerControlsStyle = (theme, width = "598px") => (
    css`
        display: flex;
        padding: 1.25rem;
        background: ${theme.palette.background.card};
        position: fixed;
        bottom: 0;
        width: ${width};
        @media (max-width: 720px) {
            padding-left: 0;
            padding-right: 0;
            flex-direction: row;
        }
    `);

const discardButtonStyle = (theme) => css`
    background: #eee;
    margin: 0 10px;
    float: left;
    height: 42px;
    font-size: 15px;
`;

const drawerContentStyle = (theme) => css`
    padding: 0;
    color: ${theme.palette.text.main};
    height: calc(100% - 124px);
    overflow-y: auto;
`;

const emptyStateStyle = (theme) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 2rem;
    color: ${theme.palette.text.disabled};
    font-size: 1.2rem;
    text-align: center;
`;

export default KpiDrawerFallback;